import { render, staticRenderFns } from "./ReviewLove.vue?vue&type=template&id=d24971c2"
import script from "./ReviewLove.vue?vue&type=script&lang=js"
export * from "./ReviewLove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports